import { VRuntimeShell } from '@grupoa/components';
import { mapState, mapGetters } from 'vuex';

export default {
  name       : 'NoticePopUp',
  components : {
    VRuntimeShell
  },
  props: {
    noticeConfigs: {
      type     : Object,
      required : true
    }
  },
  data() {
    return {
      applicationBaseUrl: process.env.APPLICATION_ROUTE_BASE
    };
  },
  computed: {
    ...mapState({
      tenantsRights: (state) => state._core.auth.tenantsRights
    }),
    ...mapGetters({
      isImpersonated: '_core/auth/isImpersonated'
    }),
    isAdministrador() {
      if (!this.tenantsRights || !Array.isArray(this.tenantsRights)) {
        return false;
      }

      for (const tenant of this.tenantsRights) {
        if (tenant.roles && tenant.roles.some(role => role.roleId === 1)) {
          return true;
        }

        if (tenant.ies && tenant.ies.some(ies => ies.roles.some(role => role.roleId === 1))) {
          return true;
        }
      }

      return false;
    }
  },
  methods: {
    handleMainButtonClick() {
      if (this.noticeConfigs.buttonLink) {
        window.open(this.noticeConfigs.buttonLink, '_blank');
      }
      this.$emit('action', { hasAgreed: true });
    },
    handleCloseClick() {
      this.$emit('close');
    }
  }
};